module.exports = __webpack_public_path__ + "c5f6ac345b473f918c87175af2ef316c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-jidannda.png
// module id = 2031
// module chunks = 4